import { z } from 'zod';
import { marketingOptOutSchema } from '../Forms/components/MarketingOptOut/validation';

const FORTY_CHARACTERS = 40;
const EIGHTY_CHARACTERS = 80;
const TWO_HUNDRED_CHARACTERS = 200;
const FIVE_HUNDRED_CHARACTERS = 500;

export const serpFormSchema = z
  .object({
    first_name: z.string().max(FORTY_CHARACTERS).min(1, 'Required field'),
    last_name: z.string().max(EIGHTY_CHARACTERS).min(1, 'Required field'),
    title: z.string().max(EIGHTY_CHARACTERS).min(1, 'Required field'),
    academic_email: z
      .string()
      .min(1, 'Required field')
      .email('Invalid email format')
      .max(EIGHTY_CHARACTERS),
    country: z
      .object({
        label: z.string(),
        value: z.string(),
      })
      .nullable()
      .transform((data, ctx) => {
        if (data === null) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Required field',
          });

          return z.NEVER;
        }

        return data.value;
      }),
    application_for: z.literal('research_grants').or(z.literal('education')),
    // Research Grants fields
    university_lab_affiliation: z.string().max(TWO_HUNDRED_CHARACTERS).optional(),
    research_purpose: z.string().max(FIVE_HUNDRED_CHARACTERS).optional(),
    useful_links: z.string().optional(),
    // Education Program fields
    university_course_name: z.string().max(TWO_HUNDRED_CHARACTERS).optional(),
    number_of_students: z.number().min(1, 'Must be at least 1').int().optional().nullable(),
    faculty_directory_link: z.string().optional(),
    form_type: z.literal('serp'),
    campaign_id: z.string(),
    ...marketingOptOutSchema.shape,
  })
  .superRefine((data, ctx) => {
    // Validate Research Grants fields
    if (data.application_for === 'research_grants') {
      if (!data.university_lab_affiliation) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required field',
          path: ['university_lab_affiliation'],
        });
      }
      if (!data.research_purpose) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required field',
          path: ['research_purpose'],
        });
      }
    }

    // Validate Education Program fields
    if (data.application_for === 'education') {
      if (!data.university_course_name) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required field',
          path: ['university_course_name'],
        });
      }
      if (!data.number_of_students) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required field',
          path: ['number_of_students'],
        });
      }
    }
  });
